import { render, staticRenderFns } from "./guestList.vue?vue&type=template&id=5b7a452d"
import script from "./guestList.vue?vue&type=script&lang=js"
export * from "./guestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports